import React from 'react';
import { FadeIn } from './FadeIn';
export function ProblemSection() {
  return <section className="bg-cream-dark py-6 px-4 md:px-8" data-id="element-155">
      <div className="max-w-2xl mx-auto" data-id="element-156">
        <FadeIn data-id="element-157">
          <h2 className="text-xl md:text-2xl font-bold text-forest mb-3 text-center" data-id="element-158">
            Why You Wake Up Feeling Like This
          </h2>
        </FadeIn>

        <FadeIn delay={0.15} data-id="element-159">
          <div className="space-y-3 text-sm md:text-base text-charcoal leading-relaxed" data-id="element-160">
            <p data-id="element-161">
              For most women over 60, this daily stiffness isn't just
              "aging"—it's systemic inflammation. Your body is essentially
              "stewing" in inflammatory triggers while you sleep, leaving your
              joints swimming in cellular waste by 7:00 AM.
            </p>
            <p data-id="element-162">
              The tragedy is that most "health advice" makes it worse. You're
              told to exercise more when it hurts to walk to the mailbox, or
              given complex 300-page cookbooks that require an hour of standing
              and painful vegetable chopping.
            </p>
            <p className="font-semibold text-forest text-lg mt-3 text-center" data-id="element-163">
              You don't need a gourmet diet; you need a "greasier" internal
              system.
            </p>
          </div>
        </FadeIn>
      </div>
    </section>;
}